import { AxiosError } from 'axios';
import { put } from 'redux-saga/effects';

import { HideToast, ShowToast } from '@/store/toast/actions';
import { Logger } from '@/services/errors/appLogger';

import translationInstance from '../../../i18n';

const parseParams = (params: string[]) => params && params?.reduce((acc, val, idx) => ({ ...acc, [idx]: val }), {});

export const isAxiosError = <T extends Record<'Error' | 'ErrorParams' | 'MessageID' | 'MessageParts', any>>(
    e: Error | AxiosError<T>
): e is AxiosError<T> => (e as AxiosError)?.response !== undefined;

export function* errorToast(e: AxiosError<Record<'Error' | 'MessageID', any>, any> | Error): any {
    const message = isAxiosError(e) ? e?.response?.data?.Error : e?.message;

    const { id, params, defaultValue } = isAxiosError(e)
        ? {
              id: e?.response?.data?.MessageID,
              defaultValue: message,
              params: parseParams(e?.response?.data?.MessageParts) || {},
          }
        : ({ defaultValue: message } as any);

    Logger.error(message);

    // we need to assume th at params will be parsed as {0: vlaue, 1: value, ...} so please adjust translations accordingly
    const getTranslatedErrorMessage = () => translationInstance.t(id, { defaultValue, ...params }) || defaultValue;

    yield put(
        ShowToast({
            severity: 'error',
            message: `Error: ${getTranslatedErrorMessage()}`,
            duration: 6000,
            onClose: HideToast,
        })
    );
}
